import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2Request,
    Mk2Response,
    Pagination
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { ScheduleResultRule, ScheduleResultsRequest } from '../../_generated';
import { ScheduleResult as ScheduleResultsResponse } from '../../_generated/model/scheduleResult';
import { ASAP_API_SERVICE_NAME } from '../constants/common-constants';

export class ListScheduleResultsRequest extends Mk2Request {
    scheduleID?: number;
    pagination?: Pagination;

    constructor(initial?: Partial<ListScheduleResultsRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class ListScheduleResultsResponse extends Mk2Response {
    rulesetName?: string;
    rules?: Array<ScheduleResultRule>;
    amountPassed?: number;
    amountFailed?: number;
    success?: boolean;
    resultDate?: string;
    batchNumber?: number;
    pages?: number;
    timeReceived?: string;
    totalInvoices?: number;
    debtorCount?: number;
    totalCount?: number;
    clientName?: string;
    scheduleID?: number;
    pagination?: Pagination;

    constructor(initial?: Partial<ListScheduleResultsResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class ListScheduleResultService extends ApiService<
    ListScheduleResultsRequest,
    ListScheduleResultsResponse
> {
    public requestType = ListScheduleResultsRequest;
    public responseType = ListScheduleResultsResponse;
    public endpointName = 'v1/purchasing/auto-approval/schedules/result';
    public serviceName = ASAP_API_SERVICE_NAME;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
        this.usePascalForUrl = false;
    }

    public requestMapper(req: ListScheduleResultsRequest): ScheduleResultsRequest {
        return {
            scheduleID: req.scheduleID
        };
    }

    public responseMapper(res: ScheduleResultsResponse): ListScheduleResultsResponse {
        return {
            ok: true,
            rows: res.rules,
            totalCount: res.totalCount,
            amountFailed: res.amountFailed,
            amountPassed: res.amountPassed,
            batchNumber: res.batchNumber,
            debtorCount: res.debtorCount,
            pages: res.pages,
            resultDate: res.resultDate,
            rulesetName: res.rulesetName,
            success: res.success,
            timeReceived: res.timeReceived,
            clientName: res.clientName,
            scheduleID: res.scheduleID,
            totalInvoices: res.totalInvoices
        };
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }
}
